// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../assets/logo-large.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".goformz-logo-container{height:55px;min-height:55px}.light-theme .goformz-logo-container{background-color:#0b99c2}.dark-theme .goformz-logo-container{background-color:#227b99}.goformz-logo-container .goformz-logo-wrapper{margin-top:11px;padding-left:12px}.goformz-logo-container .goformz-logo-wrapper .goformz-logo{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");height:32px;width:131px}", ""]);
// Exports
module.exports = exports;
